import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'

export const createSegment = async (user_id: string, filters: any) => {
  const axios = AxiosInitializer({ token: getToken() })

  const data = {
    data: {
      attributes: {
        segments: {
          user_id,
          filters,
        },
      },
    },
  }

  const response = await axios.post('/participant_segments', data)

  return response.data.data.id
}
